import React from 'react';
import './cancel_refund.css'; // Reusing the same CSS file for consistent styling

const ShippingPolicy = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Shipping &amp; Delivery Policy</h1>
      <p className="policy-last-updated">Last Updated: December 1, 2025</p>

      <section className="policy-section">
        <h2 className="section-title">1. Nature of Products</h2>
        <p>PrrepX Pathshala primarily offers **digital educational services**. Our current offerings include online Paid Test Series, Paid Courses, and future online/offline Batches. These products are delivered digitally or through access to physical locations (in the case of future offline batches), and therefore, do not require conventional physical shipping.</p>
      </section>

      <section className="policy-section">
        <h2 className="section-title">2. Digital Delivery (Current Operations)</h2>
        <p>All purchased digital products, such as Test Series subscriptions and Online Course access, are delivered instantly upon successful payment completion.</p>
        <ul className="policy-list">
          <li>**Delivery Method:** Access is granted immediately via your registered user account on our platform: <a href="https://testseries.prrepxpathsala.live" target="_blank" rel="noopener noreferrer">https://testseries.prrepxpathsala.live</a> or <a href="https://prrepxpathshala.live" target="_blank" rel="noopener noreferrer">https://prrepxpathshala.live</a>.</li>
          <li>**Confirmation:** You will receive a confirmation email with your enrollment details shortly after your payment is successfully processed.</li>
          <li>**Delivery Time:** Instant (access is granted immediately upon payment success).</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2 className="section-title">3. Future Physical Product Shipping</h2>
        <p>We acknowledge that PrrepX Pathshala may introduce physical educational materials (e.g., textbooks, study guides, merchandise) in the future.</p>
        <p>Should we begin shipping physical products, this Shipping Policy will be updated immediately to include detailed information on:</p>
        <ul className="policy-list">
          <li>Shipping locations (Domestic/International).</li>
          <li>Shipping charges and costs.</li>
          <li>Estimated delivery times.</li>
          <li>Tracking information.</li>
        </ul>
        <p>Any current purchase of digital goods will remain subject only to the Digital Delivery terms above.</p>
      </section>
      
      <section className="policy-section">
        <h2 className="section-title">4. Contact Information</h2>
        <p>For any queries regarding the delivery of your purchased services, please contact us via the details provided on our <a href="https://testseries.prrepxpathshala.live/contact-us" target="_blank" rel="noopener noreferrer">Contact Us</a> page.</p>
        <p>Email ID: support@prrepxpathshala.live  Contact Number: +918287648766(Only WhatsaApp)</p>
      </section>
    </div>
  );
};

export default ShippingPolicy;